import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	icon: {
		width: "32px",
		height: "32px",
		color: colors.purple[800]
	},
	editIcon: {
		color: colors.gray[700],
		fontSize: "20px"
	},
	listItemButton: {
		background: colors.gray[100],
		opacity: "0.7",
		width: "64px",
		height: "64px",
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	}
}))

export default useStyles
